import { createStore } from "vuex";

export default createStore({
  state: {
    projectName: "",
    project: {},
    avatar: require("@/assets/user.svg"),
    userType: "",
    act_operations: null,
  },
  mutations: {
    setProjectName(state, name) {
      state.projectName = name;
    },
    setProject(state, project) {
      state.project = project;
    },
    setActOperations(state, operations) {
      state.act_operations = operations;
    },
    setAvatar(state) {
      // eslint-disable-next-line
      state.avatar = `backend/users/${atob(localStorage.getItem("isLogged")).split(" ")[0]
        // eslint-disable-next-line
        }/avatar.jpg?${new Date().getTime()}`;
    },
    clearAvatar(state) {
      state.avatar = require("@/assets/user.svg");
    },
    setUserType(state, type) {
      state.userType = type;
    },
  },
  actions: {
    async getAvatar(state) {
      if (localStorage.getItem("isLogged")) {
        const resp = await fetch("/backend/users.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: localStorage.getItem("isLogged"),
          },
          body: JSON.stringify({
            action: "getUserData",
          }),
        });

        const data = await resp.json();

        if (data.avatar !== '0') {
          state.commit("setAvatar");
        } else {
          state.commit("clearAvatar");
        }
      }
    },
    async getProjectName(state, id) {
      if (id) {
        let resp = await fetch("/backend/projects.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: localStorage.getItem("isLogged"),
          },
          body: JSON.stringify({
            action: "getProjects",
          }),
        });
        const projects = await resp.json();
        state.commit("setProjectName", projects.find((i) => i.id === id).name);
      }
    },
    async getProject(state, id) {
      if (id) {
        let resp = await fetch("/backend/projects.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: localStorage.getItem("isLogged"),
          },
          body: JSON.stringify({
            action: "getProjects",
          }),
        });
        const projects = await resp.json();
        state.commit(
          "setProject",
          projects.find((i) => i.id === id)
        );
      }
    },
    async getUserType(state) {
      let resp = await fetch("/backend/users.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: localStorage.getItem("isLogged"),
        },
        body: JSON.stringify({
          action: "getUserType",
        }),
      });
      const type = await resp.json();
      // state.commit("setProjectName", projects.find((i) => i.id == id).name);
      state.commit("setUserType", type);
    },
  },
  getters: {
    projectName(state) {
      return state.projectName;
    },
    project(state) {
      return state.project;
    },
    avatar(state) {
      return state.avatar;
    },
    userType(state) {
      return state.userType;
    },
    actOperations(state) {
      return state.act_operations;
    },
  },
  modules: {},
});
